import Cookies from "js-cookie";
import EnumsContext from "../../../../context/enums-context";
import { buildGroupHierarchy, convertSumWithLatestCurrencyRate, formatCurrency, formatQuantityWithMeasurement, formatShortDate, useEnumLabel } from "../../../../Utils/Utils";
import { Guid } from "js-guid";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Sidebar } from "primereact/sidebar";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { TreeSelect } from "primereact/treeselect";

import commonStyle from "../../CommonStyles.module.css";
import useApi from "../../../../Utils/BackendClient";
import HistoryElement from "../../../UIElements/HistoryElement";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import ActPayments from "../../../UIElements/ActPayments";
import DocumentPrintSidebar from "../../../UIElements/DocumentPrintSidebar";
import DocumentArchiveTable from "../../../UIElements/DocumentArchiveTable";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import DiscountInput from "../../../UIElements/Inputs/DiscountInput";
import TextInput from "../../../UIElements/Inputs/TextInput";
import { numberEditor } from "../../../../Utils/TableEditors";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import CounterAgentCreationSidebar from "../../../UIElements/Sidebars/CounterAgentCreationSiidebar";
import NumberInput from "../../../UIElements/Inputs/NumberInput";
import { Message } from "primereact/message";
import CurrencyAmountInput from "../../../UIElements/Inputs/CurrencyAmountInput";

const NewSale = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);
    const { createSaleAct, deletePaymentFromAct, fetchActPayments, fetchProductsExtended, fetchRemainings, fetchRemainingsByService, fetchSaleActDetails, fetchSaleActDocuments, fetchSaleActHistory, fetchServices, fetchServicesExtended, updateSaleAct } = useApi();

    const [actData, setActData] = useState(
        {
            cagent: null,
            division: null,
            act_date: new Date(),
            act_number_autogenerate: true,
            act_number: "",
            discount: [],
            pay_due_date: new Date(),
            pay_status: null,
            status: "Драфт",
            unidentified_products: [],
            identified_products: [],
            services: [],
            templates: []
        });
    const [actHistory, setActHistory] = useState(null);
    const [actPayments, setActPayments] = useState(null);
    const [attachedProducts, setAttachedProducts] = useState(null);
    const [cagentCreationSidebarVisible, setCagentCreationSidebarVisible] = useState(false);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditField, setIsEditField] = useState(false);
    const [isFinalized, setIsFinalized] = useState(false);
    const [isProducts, setIsProducts] = useState(false);
    const [loading, setLoading] = useState(false);
    const [printDocuments, setPrintDocuments] = useState(false);
    const [productAttachedSidebarVisible, setProductAttachedSidebarVisible] = useState(false);
    const [productGroups, setProductGroups] = useState([]);
    const [productLazyState, setProductlazyState] = useState(
        {
            first: 0,
            rows: 20,
            page: 1,
            sortField: "created_at",
            sortOrder: 1,
            filters: {
                product_group: { value: null, matchMode: 'equals' },
                division: { value: null, matchMode: 'equals' }
            }
        }
    );
    const [products, setProducts] = useState();
    const [productsTotalRecords, setProductsTotalRecords] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const [serviceGroups, setServiceGroups] = useState([]);
    const [serviceLazyState, setServicelazyState] = useState(
        {
            first: 0,
            rows: 20,
            page: 1,
            sortField: "created_at",
            sortOrder: 1,
            filters: {
                service_group: { value: null, matchMode: 'contains' },
            }
        }
    );
    const [services, setServices] = useState();
    const [servicesTotalRecords, setServicesTotalRecords] = useState(0);
    const [showActBaseOnMobile, setShowActBaseOnMobile] = useState(true);
    const [showfields, setShowFields] = useState(false);
    const [showProductChooseMenu, setProductChooseMenu] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [totaLActSum, setTotalActSum] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [unChangedRemainings, setUnChangedRemainings] = useState([]);
    const [visible, setVisible] = useState(false);

    const enumTypes = useMemo(() => ["divisions", "clients", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getClientLabel = useEnumLabel(ctx.enums.clients.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    useEffect(() => {

        const loadProductGroups = async () => {
            const response = await fetchProductsExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setProductGroups(groups);
            }
        }

        const loadServiceGroups = async () => {
            const response = await fetchServicesExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setServiceGroups(groups);
            }
        }

        loadProductGroups();
        loadServiceGroups();
    }, [fetchProductsExtended, fetchServicesExtended]);

    useEffect(() => {
        if (location.state !== null) {
            if (location.state.id != null) {

                setIsEdit(true);

                const fetchData = async () => {

                    const response = await fetchSaleActDetails(location.state.id);

                    if (response.status === 200) {

                        setIsFinalized(response.data.status !== "PENDING");
                        response.data.act_date = new Date(response.data.act_date);
                        response.data.pay_due_date = new Date(response.data.pay_due_date);

                        if (response.data.identified_products.length > 0) {
                            response.data.identified_products.forEach(element => {
                                element.fe_id = Guid.newGuid().toString();
                                element.totalPrice = element.price;
                                element.totalPriceUAH = element.priceUAH;
                            });
                        }
                        if (response.data.unidentified_products.length > 0) {
                            response.data.totalPrice = response.data.price * response.data.quantity;
                            response.data.unidentified_products.forEach(element => {
                                element.fe_id = Guid.newGuid().toString();
                                element.totalPrice = element.price * element.quantity;
                                element.totalPriceUAH = element.priceUAH * element.quantity;
                            });
                        }
                        if (response.data.services.length > 0) {
                            response.data.services.forEach(element => {
                                element.fe_id = Guid.newGuid().toString();
                                element.totalPrice = element.price;
                                element.totalPriceUAH = element.priceUAH;
                            });
                        }

                        let discount = 0;
                        if (response.data.discount.length > 0) {
                            discount = response.data.discount.reduce((accumulator, element) => accumulator + +convertSumWithLatestCurrencyRate(element.currency, element.amount), 0);
                        }

                        setTotalDiscount(discount);
                        setActData(response.data);
                    }
                }

                fetchData();
            }
            else {
                let saleActData = {
                    cagent: null,
                    division: Cookies.get("division"),
                    currency: "UAH",
                    act_date: new Date(),
                    act_number_autogenerate: true,
                    act_number: "",
                    discount: [],
                    pay_due_date: new Date(),
                    status: "Драфт",
                    unidentified_products: [],
                    identified_products: [],
                    services: [],
                    templates: []
                };

                const item = location.state.item;

                item.fe_id = Guid.newGuid().toString();
                item.product = item.product_name;
                item.price = +item.sale_price;
                item.currency = item.sale_price_currency;
                item.priceUAH = convertSumWithLatestCurrencyRate(item.sale_price_currency, item.price)
                item.remaining_id = item.id;

                if (location.state.item.identifier !== undefined) {
                    item.totalPrice = +item.sale_price;
                    item.totalPriceUAH = item.priceUAH;
                    saleActData.identified_products = [item];
                }
                else {
                    item.totalPrice = +item.sale_price * item.quantity;
                    item.totalPriceUAH = item.priceUAH * item.quantity;
                    saleActData.unidentified_products = [item];
                }

                setActData(saleActData);
            }

        }
    }, [location.state, fetchSaleActDetails]);

    const formik = useFormik({
        initialValues: actData,
        enableReinitialize: true,
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                identified_products: transformIdProducts(values.identified_products),
                unidentified_products: transformUnIdProducts(values.unidentified_products),
                services: transFormServices(values.services),
                act_number: values.act_number_autogenerate ? 0 : values.act_number
            }

            function transformIdProducts(data) {

                return data.map(product => {

                    console.log(product);

                    if (product.remaining_id === undefined) {
                        const index = unChangedRemainings.findIndex(function (field) {
                            return field.identifier === product.identifier;
                        });

                        product.remaining_id = unChangedRemainings[index].id;
                    }
                    delete product.id;
                    delete product.product;
                    delete product.fe_id;
                    delete product.totalPrice;
                    delete product.totalPriceUAH;
                    delete product.identifier;

                    return product;
                });
            }

            function transformUnIdProducts(data) {
                console.log(data);

                return data.map(product => {
                    if (product.isNew !== undefined) {
                        product.remaining_id = product.id;
                    }

                    delete product.id;
                    delete product.fe_id;
                    delete product.totalPrice;
                    delete product.totalPriceUAH;
                    delete product.isNew;

                    return product;
                });
            }

            function transFormServices(data) {
                const formatedServices = [];

                data.forEach(service => {
                    const formattedService = {
                        price: service.price,
                        priceUAH: service.priceUAH,
                        currency: service.currency,
                        service_id: service.isNew ? service.id : service.service_id
                    }

                    formatedServices.push(formattedService);
                });

                return formatedServices;
            }

            const response = isEdit ? await updateSaleAct(location.state.id, payload) : await createSaleAct(payload);
            const successStatus = isEdit ? 200 : 201;

            setSubmitLoading(false);

            if (response.status === successStatus) {
                const toastMessage = isEdit ? { severity: "success", summary: "Успіх редагування", detail: "Акт успішно відредаговано", life: 3000 } :
                    { severity: "success", summary: "Успіх створення", detail: "Акт успішно створено", life: 3000 }

                navigate("/sales", { state: { toast: toastMessage } });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    //total amount calculation
    useEffect(() => {
        let calcAmount = 0;

        if (formik.values?.identified_products?.length > 0) {
            calcAmount += formik.values.identified_products.reduce((sum, prod) => sum + prod.priceUAH, 0);
        }

        if (formik.values?.unidentified_products?.length > 0) {
            calcAmount += formik.values.unidentified_products.reduce((sum, prod) => sum + prod.priceUAH * prod.quantity, 0);
        }

        if (formik.values?.services?.length > 0) {
            calcAmount += formik.values.services.reduce((sum, prod) => sum + prod.priceUAH, 0);
        }

        setTotalActSum(calcAmount);

    }, [formik.values.identified_products, formik.values.services, formik.values.unidentified_products]);

    const sideBarFormik = useFormik({
        initialValues: {
            type: '',
            product: "",
            product_group: "",
            id: "",
            identifier: "",
            quantity: null,
            currency: "",
            price: null,
            totalPrice: null,
            priceUAH: null,
            totalPriceUAH: null,
            measurement_units: "PIECES",
            attached_products: false,
            fe_id: null,
            discount: []
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.type !== "SERVICE") {
                if (values.type === "PIECE") {
                    if (values.quantity === undefined) {
                        errors.quantity = "Введіть кількість товару"
                    }
                    else if (+values.quantity <= 0) {
                        errors.quantity = "Кількість товарів не повинна бути меншою від 1 шт."
                    }
                    else if (+values.total_quantity < +values.quantity) {
                        errors.quantity = "Кількість товарів не повинна бути більшою ніж на складі: " + +values.total_quantity
                    }
                }

                if (!values.price || +values.price <= 0) {
                    errors.price = "Введіть вартість товару вищу від 0"
                }

                if (!values.priceUAH || +values.priceUAH <= 0) {
                    errors.priceUAH = "Введіть вартість товару вищу від 0"
                }
            }

            return errors;
        },
        onSubmit: async (values) => {

            let newValue = {
                id: values.id,
                product: values.product,
                currency: values.currency,
                price: +values.price,
                totalPrice: +values.totalPrice,
                priceUAH: +values.priceUAH,
                totalPriceUAH: +values.totalPriceUAH,
                measurement_units: values.measurement_units
            };

            let arrayName = null;

            if (values.type === "INDIVIDUAL") {
                arrayName = "identified_products";
                newValue.identifier = values.identifier;
                newValue.remaining_id = values.remaining_id;
                //remove from remainings
                if (!isEditField) {
                    const index = products.findIndex(function (field) {
                        return field.identifier === values.identifier;
                    });
                    products.splice(index, 1);
                }
            }
            else if (values.type === "PIECE") {
                arrayName = "unidentified_products";
                newValue.quantity = values.quantity;
                newValue.isNew = true;
                if (!isEditField) {
                    const index = products.findIndex(function (field) {
                        return field.product_name === newValue.product;
                    });

                    products[index].total_quantity = products[index].total_quantity - values.quantity;
                }

            }
            else {
                arrayName = "services";
                newValue.service = values.product;
                newValue.isNew = true;
            }

            let updatedArray = formik.values[arrayName];

            if (isEditField) {
                updatedArray = updatedArray.map(item =>
                    item.fe_id === values.fe_id ? newValue : item
                );
            }
            else {
                newValue.fe_id = Guid.newGuid().toString();
                updatedArray = [...updatedArray, newValue];
            }

            formik.setFieldValue(arrayName, updatedArray);

            if (!isEditField) {
                setProductChooseMenu(true);
            }
            else {
                setVisible(false);
                setIsEditField(false);
            }

            setShowFields(false);

            if (values.attached_products) {
                const response = await fetchRemainingsByService(formik.values.division, values.id);

                if (response.status === 200) {
                    if (response.data?.filter(product => product.total_quantity - product.booked > 0)?.length > 0) {
                        setAttachedProducts(response.data);
                        setProductAttachedSidebarVisible(true);
                    }
                    else {
                        toast.current.show({ severity: "info", summary: "Прикріплені товари", detail: "Прикріплені товари не було додано, оскільки немає залишку на складі", life: 3000 });
                    }
                }
            }

            sideBarFormik.resetForm();
        }
    })

    const DeleteFieldHandler = (rowData, array) => {
        const newArray = formik.values[array].filter(obj => obj.fe_id !== rowData.fe_id);

        formik.setFieldValue(array, newArray);
    };

    const EditFieldHandler = (rowData, array) => {
        setIsEditField(true);
        setShowFields(true);
        setVisible(true);

        const typeMap = {
            identified_products: "INDIVIDUAL",
            unidentified_products: "PIECE",
        };

        const type = typeMap[array] ?? "services";

        if (array === "unidentified_products") {
            sideBarFormik.setFieldValue("quantity", rowData.quantity);
        }

        sideBarFormik.setValues({
            ...sideBarFormik.values,
            type,
            fe_id: rowData.fe_id,
            identifier: rowData.identifier,
            quantity: rowData.quantity ?? 1,
            id: rowData.remaining_id ?? rowData.id,
            product: rowData.product,
            currency: rowData.currency,
            price: rowData.price,
            totalPrice: rowData.totalPrice,
            priceUAH: rowData.priceUAH,
            totalPriceUAH: rowData.totalPriceUAH,
            remaining_id: rowData.remaining_id
        });
    };

    const AddButtonHandler = (isProduct) => {
        setVisible(true);
        setProductChooseMenu(true);
        setIsProducts(isProduct);
    }

    const closeSideBarHandler = () => {
        setVisible(false);
        setShowFields(false);
        setSelectedItem(null);
        setIsEditField(false);
        setProducts([]);
        setServices([]);
    }

    const getGroupData = async (state) => {
        const response = isProducts ? await fetchRemainings(state) : await fetchServices(state);

        if (response.status === 200) {
            if (isProducts) {
                const unchangedProducts = [...unChangedRemainings, ...response.data.results];
                setUnChangedRemainings(unchangedProducts);
                setProducts(response.data.results);
                setProductsTotalRecords(response.data.count);
            }
            else {
                setServices(response.data.results);
                setServicesTotalRecords(response.data.count);
            }

            setLoading(false);
        }
    }

    const setGroupValue = (id) => {
        setSelectedItem(id);
        setLoading(true);

        let filterGroup = null;

        if (id !== null && id !== undefined) {
            if (id.toString().includes('-')) {
                var keys = id.split('-');
                filterGroup = keys[(keys.length - 1)];
            }
            else {
                filterGroup = id;
            }
        }

        if (isProducts) {
            const newState = productLazyState;

            newState.filters.product_group.value = filterGroup;
            newState.filters.division.value = formik.values.division;

            setProductlazyState(newState);

            getGroupData(productLazyState);
        }
        else {
            const newState = serviceLazyState;

            newState.filters.service_group.value = filterGroup;

            setServicelazyState(newState);

            getGroupData(serviceLazyState);
        }
    }

    const setDivision = (id) => {

        formik.setFieldValue("division", id);

        if (selectedItem) {
            if (isProducts) {
                const newState = productLazyState;
                productLazyState.filters.division.value = formik.values.division;
                setProductlazyState(newState);
                getGroupData(productLazyState);
            }
            else {
                getGroupData(serviceLazyState);
            }
        }
    }

    const onProductsPage = event => {
        event.page = event.page + 1;
        setProductlazyState(event);
    }

    const onServicePage = event => {
        event.page = event.page + 1;
        setServicelazyState(event);
    }

    const BackToProductsHandler = () => {
        setShowFields(false);
        setProductChooseMenu(true);

        sideBarFormik.resetForm();
    }

    const AddProductToTableHandler = rowData => {

        if (rowData.service_group != null) {
            sideBarFormik.setFieldValue('type', "SERVICE");
            sideBarFormik.setFieldValue('product', rowData.name);
            sideBarFormik.setFieldValue('currency', rowData.currency)
            sideBarFormik.setFieldValue('price', rowData.price)
            sideBarFormik.setFieldValue('totalPrice', rowData.price)
            sideBarFormik.setFieldValue('priceUAH', convertSumWithLatestCurrencyRate(rowData.currency, rowData.price))
            sideBarFormik.setFieldValue('totalPriceUAH', convertSumWithLatestCurrencyRate(rowData.currency, rowData.price))
            sideBarFormik.setFieldValue('attached_products', rowData.attached_products);
        }
        else {
            sideBarFormik.setFieldValue('product', rowData.product_name);
            sideBarFormik.setFieldValue('currency', rowData.sale_price_currency)
            sideBarFormik.setFieldValue('price', rowData.sale_price)
            sideBarFormik.setFieldValue('totalPrice', rowData.sale_price)
            sideBarFormik.setFieldValue('priceUAH', convertSumWithLatestCurrencyRate(rowData.sale_price_currency, rowData.sale_price))
            sideBarFormik.setFieldValue('totalPriceUAH', convertSumWithLatestCurrencyRate(rowData.sale_price_currency, rowData.sale_price))
            sideBarFormik.setFieldValue('measurement_units', rowData.measurement_units)

            if (rowData.identifier != null) {
                sideBarFormik.setFieldValue('type', "INDIVIDUAL");
                sideBarFormik.setFieldValue('identifier', rowData.identifier);
            }
            else {
                sideBarFormik.setFieldValue('type', "PIECE");
            }
        }

        sideBarFormik.setFieldValue('id', rowData.id);
        sideBarFormik.setFieldValue("quantity", rowData.quantity === undefined ? 1 : rowData.quantity);
        sideBarFormik.setFieldValue("total_quantity", rowData.total_quantity);

        setProductChooseMenu(false);
        setShowFields(true);
    }

    const AddServiceProductsToTable = (products) => {
        let newUnIdentifiedProducts = [];
        let newIdentifiedProducts = [];

        console.log(products);

        products.forEach(element => {

            let newValue = {
                id: element.remaining_id,
                fe_id: Guid.newGuid().toString(),
                product: element.product_name,
                currency: element.sale_price_currency,
                price: +element.sale_price,
                totalPrice: +element.sale_price,
                priceUAH: convertSumWithLatestCurrencyRate(element.sale_price_currency, +element.sale_price),
                totalPriceUAH: convertSumWithLatestCurrencyRate(element.sale_price_currency, +element.sale_price),
                measurement_units: element.measurement_units
            };

            if (element.identifier) {
                newValue.identifier = element.identifier;
                newValue.remaining_id = element.remaining_id;
                newIdentifiedProducts = [...newIdentifiedProducts, newValue];
            }
            else {
                newValue.quantity = 1;
                newValue.isNew = true;
                newUnIdentifiedProducts = [...newUnIdentifiedProducts, newValue];
            }
        });

        if (newUnIdentifiedProducts.length > 0) {
            const newUnIdProducts = [...formik.values.unidentified_products, ...newUnIdentifiedProducts]

            console.log(newUnIdProducts);

            formik.setFieldValue('unidentified_products', newUnIdProducts);
        }

        if (newIdentifiedProducts > 0) {
            const newUnIdProducts = [...formik.values.identified_products, ...newIdentifiedProducts]
            formik.setFieldValue('identified_products', newUnIdProducts);
        }

        setProductAttachedSidebarVisible(false);
    }

    const setQuantity = (quantity) => {
        sideBarFormik.setFieldValue("quantity", quantity);
        const totalPrice = quantity * sideBarFormik.values.price
        sideBarFormik.setFieldValue("totalPrice", totalPrice);
        sideBarFormik.setFieldValue("totalPriceUAH", convertSumWithLatestCurrencyRate(sideBarFormik.values.currency, totalPrice));
    }

    const UnbindPayment = async (paymentId) => {

        const request = {
            act_id: location.state.id,
            payment_id: paymentId
        }

        const response = await deletePaymentFromAct(request);

        if (response.status === 204) {

            const index = actPayments.findIndex(payment => payment.id === paymentId);
            if (index !== -1) {
                // Create a new array with the element removed
                const newPayments = [...actPayments.slice(0, index), ...actPayments.slice(index + 1)];

                // Set the updated state
                setActPayments(newPayments);
            }

            toast.current.show({ severity: "success", summary: "Платіж відвязано", detail: "Платіж відвязано від акту", life: 3000 });

        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка відвязки платежу", detail: "Платіж не відвязано від акту. Код помилки: " + response.status, life: 3000 });
        }
    }

    const getSaleActPayments = async (id) => {

        const response = await fetchActPayments(location.state.id);

        if (response.status === 200) {
            setActPayments(response.data.results);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання платежів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getSaleActHistory = async (id, state) => {

        const response = await fetchSaleActHistory(id, state);

        if (response.status === 200) {
            setActHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getDocumentsArchive = async (id, lazyState) => {

        const response = await fetchSaleActDocuments(id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getSaleActHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(location.state.id, event);

        setDocArchiveLazyState(event);
    }

    const printDocumentHandler = () => {
        setPrintDocuments(true);
    }

    const HandleCagentCreation = async (id) => {
        formik.setFieldValue("cagent", id);
    }

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const RecalculateSumWithLatestCurrencyRate = (rowData, array) => {
        const newSumUAH = convertSumWithLatestCurrencyRate(rowData.currency, rowData.price);
        const totalSumUAH = newSumUAH * (rowData.quantity ?? 1);

        const updatedArray = formik.values[array].map(item => {
            const isMatch = rowData.fe_id
                ? item.fe_id === rowData.fe_id
                : item.id === rowData.id;

            return isMatch
                ? { ...item, priceUAH: newSumUAH, totalPriceUAH: totalSumUAH }
                : item;
        });

        formik.setFieldValue(array, updatedArray);
    }

    const confirmRecalculate = (rowData, array) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження перерахунку вартості товару в гривні',
            message: "Вартість товару " + rowData.product + " буде перераховано по курсу " + Cookies.get(rowData.currency) + " UAH за " + rowData.currency + ".",
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { RecalculateSumWithLatestCurrencyRate(rowData, array) }
        });
    }

    const items = [
        {
            label: 'Деталі акту',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isFinalized
            ? [
                {
                    label: 'Платежі',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setTabShowed(1);
                        getSaleActPayments(location.state.id);
                    },
                },
            ]
            : []),
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getSaleActHistory(location.state.id, historyLazyState);
                    },
                },
                {
                    label: 'Документи',
                    icon: 'pi pi-save',
                    command: () => {
                        setTabShowed(3);
                        getDocumentsArchive(location.state.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    const toolbarLeftData = () => {

        let name = "Створення нового акту продажу";

        if (isEdit) {
            name = "Редагування акту продажу"

            if (isFinalized) {
                name = "Інформація про акт продажу"
            }
        }

        return !isMobile ?
            <h3>{name}</h3> :
            (!isFinalized ? <Button type="button" icon={`pi ${showActBaseOnMobile ? "pi-chevron-circle-up" : "pi-chevron-circle-down"}`} severity="secondary" outlined onClick={() => setShowActBaseOnMobile(!showActBaseOnMobile)} /> : null);
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className={!isMobile ? "text-xl text-900 font-bold" : "font-bold"}>{tablename}</span>
            </div>
        );
    }

    const setPriceInFields = (value) => {

        console.log(sideBarFormik.values);
        sideBarFormik.setFieldValue("price", value);
        sideBarFormik.setFieldValue("totalPrice", value * (sideBarFormik.values.quantity ?? 1));
        sideBarFormik.setFieldValue("priceUAH", convertSumWithLatestCurrencyRate(sideBarFormik.values.currency, value));
        sideBarFormik.setFieldValue("totalPriceUAH", convertSumWithLatestCurrencyRate(sideBarFormik.values.currency, value * (sideBarFormik.values.quantity ?? 1)));
    }

    const TableFooter = (data) => {

        const totalValue = data.reduce((accumulator, element) => accumulator + element.priceUAH * (element.quantity ?? 1), 0);

        return (
            <div className={commonStyle.footerContainer}>
                <label>Cума: {formatCurrency(totalValue, "UAH")}</label>
            </div>)
    }

    const tableActionBodyTemplate = (rowData, array) => {
        return (<div className="flex flex-wrap gap-2">
            {!isFinalized && <>
                <Button
                    icon="pi pi-money-bill"
                    type="button"
                    className={`p-button-rounded p-button-success ${commonStyle.addButton}`}
                    tooltip="Перерахувати по курсу на сьогодні"
                    tooltipOptions={{ position: "top" }}
                    size="small"
                    onClick={() => confirmRecalculate(rowData, array)}
                />
                <Button
                    icon="pi pi-trash"
                    type="button"
                    className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                    tooltip="Видалити з таблиці"
                    tooltipOptions={{ showOnDisabled: true, position: "left" }}
                    size="small"
                    onClick={() => DeleteFieldHandler(rowData, array)}
                />
                <Button
                    icon="pi pi-pencil"
                    type="button"
                    className={`p-button-rounded p-button-warning ${commonStyle.warningTag}`}
                    tooltip="Редагувати"
                    tooltipOptions={{ position: "top" }}
                    size="small"
                    onClick={() => EditFieldHandler(rowData, array)}
                />
            </>}
        </div>
        );
    };

    const contentToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label="Товар" icon="pi pi-plus" severity="success" className={commonStyle.addButton} type="button" onClick={() => AddButtonHandler(true)} />
                <Button label="Послугу" icon="pi pi-plus" severity="success" className={commonStyle.addButton} type="button" onClick={() => AddButtonHandler(false)} />
            </div>
        </>);
    }

    const confirmLeave = (event) => {

        if (formik.values !== actData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/sales", { state: { pageState: location?.state?.pageState } }) }
            });

        }
        else {
            navigate("/sales", { state: { pageState: location?.state?.pageState } });
        }
    }

    const actionBodyTemplate = (rowData) => {

        const allItemsAreBooked = rowData.service_group === undefined && rowData.total_quantity === rowData.booked;

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${allItemsAreBooked ? commonStyle.closeButton : commonStyle.addButton}`}
                disabled={allItemsAreBooked}
                tooltip={allItemsAreBooked ? "Товар використано в акті" : "Додати"}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => AddProductToTableHandler(rowData)}
            />
        </div>
        );
    };

    const mobileProductBody = (rowData) => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className="font-bold">x{rowData.quantity ?? "1"} {rowData.product ?? rowData.service}</div>
                            <div>{rowData.note}</div>
                            {rowData.identifier && <div>ID: {rowData.identifier}</div>}
                            <div>Ціна за од: {formatCurrency(rowData.price, rowData.currency)}</div>
                            <div>Ціна за од, грн: {formatCurrency(rowData.priceUAH, "UAH")}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {tableActionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={isFinalized} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} onDocPrint={isEdit ? printDocumentHandler : null} />
        <ConfirmDialog group="headless" />
        <TabMenu model={items} />
        {tabShowed === 0 && <div className="grid">
            {(isMobile && (isFinalized || !showActBaseOnMobile)) && <div className="col-12 ml-3 mt-3 text-lg">
                {formik.values.act_number && <div><span className="font-bold">Aкт: </span>{"№" + formik.values.act_number}</div>}
                <div><span className="font-bold">Контрагент: </span> {getClientLabel(formik.values.cagent) ?? "(Не вказано)"}</div>
                <div><span className="font-bold">Точка продажу: </span>{getDivisionLabel(formik.values.division)}</div>
                <div><span className="font-bold">Дата акту: </span>{formatShortDate(formik.values.act_date)}</div>
                <div><span className="font-bold">Очікувана дата оплати: </span>{formatShortDate(formik.values.pay_due_date)}</div>
                <div><span className="font-bold">Статус: </span>{formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}</div>
                {isFinalized && <div><span className="font-bold">Статус оплати: </span>{getPayStatusLabel(formik.values.pay_status)}</div>}
            </div>}
            {(showActBaseOnMobile && (!isMobile || !isFinalized)) &&
                (<div className={`${!isMobile ? commonStyle.leftMenu : commonStyle.mobileActDetailsMenu} ${isMobile ? "col-12 flex flex-column align-items-center" : "col-3"}`}>
                    <DropdownInput
                        formik={formik}
                        paramName="division"
                        context={ctx.enums.divisions.data}
                        onChange={(val) => formik.setFieldValue("division", val)}
                        label="Точка продажу"
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        mandatory />
                    <DropdownInput
                        formik={formik}
                        paramName="cagent"
                        context={ctx.enums.clients.data}
                        onChange={(val) => formik.setFieldValue("cagent", val)}
                        label="Контрагент"
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        addButton={true}
                        addButtonTooltip={"Додати клієнта"}
                        addButtonAction={() => setCagentCreationSidebarVisible(true)}
                    />
                    <CalendarInput formik={formik} paramName="act_date" label="Дата акту" isDisabled={isFinalized} isMobile={isMobile} />
                    <CalendarInput formik={formik} paramName="pay_due_date" label="Очікувана дата оплати" isDisabled={isFinalized} isMobile={isMobile} />
                    <DiscountInput formik={formik} paramName="discount" isDisabled={isFinalized} isMobile={isMobile} />
                    <ActNumberWithAutogenerateInput formik={formik} showAutogenerate={!isEdit} isDisabled={isFinalized} />
                    <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <InputText value={formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}
                                    disabled
                                    className="w-full" />
                                <label>Статус</label>
                            </FloatLabel>
                        </div>
                    </div>
                </div>)}
            <div className={`${isMobile ? "col-12" : "col-7 md:col-8 lg:col-9"}`}>
                {!isFinalized && <Toolbar className="mb-4" end={contentToolbarRightTemplate}></Toolbar>}
                {(!isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products}
                    header={setTableHeader("Товари індивідуального обліку")} footer={() => TableFooter(formik.values.identified_products)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product" header="Продукт" style={{ width: '22%' }} />
                    <Column field="identifier" header="Ідентифікатор" style={{ width: '15%' }} />
                    <Column field="price" header="Ціна за одиницю" body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '12%' }} />
                    <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(rowdata.priceUAH, "UAH")} style={{ width: '12%' }} />
                    <Column field="totalPrice" header="Загальна ціна" body={(rowData) => formatCurrency(rowData.totalPrice, rowData.currency)} style={{ width: '12%' }} />
                    <Column field="totalPriceUAH" header="Загальна ціна, грн" body={(rowData) => formatCurrency(rowData.totalPriceUAH, "UAH")} style={{ width: '12%' }} />
                    <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "identified_products")} style={{ width: '24%' }} />
                </DataTable>}
                {(isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products} header={setTableHeader("Товари індивідуального обліку")}
                    footer={() => TableFooter(formik.values.identified_products)}>
                    <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                </DataTable>}
                {(!isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products}
                    header={setTableHeader("Товари поштучного обліку")} footer={() => TableFooter(formik.values.unidentified_products)} editMode="cell" tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product" header="Продукт" style={{ width: '22%' }}></Column>
                    <Column field="quantity" header="Кількість"
                        editor={(options) => numberEditor(options, options.rowData.measurement_unit === "PIECES" ? 0 : 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                        body={(rowData) => formatQuantityWithMeasurement(rowData.quantity, rowData.measurement_units)} style={{ width: '15%' }} />
                    <Column field="price" header="Ціна за одиницю" body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '12%' }} />
                    <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(rowdata.priceUAH, "UAH")} style={{ width: '12%' }} />
                    <Column field="totalPrice" header="Загальна ціна" body={(rowData) => formatCurrency(rowData.price * rowData.quantity, rowData.currency)} style={{ width: '12%' }} />
                    <Column field="totalPriceUAH" header="Загальна ціна, грн" body={(rowData) => formatCurrency(rowData.priceUAH * rowData.quantity, "UAH")} style={{ width: '12%' }} />
                    <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "unidentified_products")} style={{ width: '24%' }} />
                </DataTable>}
                {(isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products} header={setTableHeader("Товари поштучного обліку")}
                    footer={() => TableFooter(formik.values.unidentified_products)}>
                    <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                </DataTable>}
                {(!isMobile && formik.values.services.length > 0) && <DataTable value={formik.values.services}
                    header={setTableHeader("Послуги")} footer={() => TableFooter(formik.values.services)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="service" header="Послуга" style={{ width: '29%' }}></Column>
                    <Column field="price" header="Ціна в валюті розрахунку" body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '29%' }}></Column>
                    <Column field="priceUAH" header="Ціна в гривні" body={(rowdata) => formatCurrency(rowdata.priceUAH, "UAH")} style={{ width: '29%' }}></Column>
                    <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "services")} style={{ width: '13%' }} />
                </DataTable>}
                {(isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.services} header={setTableHeader("Послуги")}
                    footer={() => TableFooter(formik.values.services)}>
                    <Column field="service" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                </DataTable>}
                {(formik.values.unidentified_products.length > 0 || formik.values.identified_products.length > 0 || formik.values.identified_products.length > 0) && <><div className={commonStyle.footerContainer}>
                    <h3>Загальна сума акту: {formatCurrency(totaLActSum, "UAH")}</h3>
                </div>
                    <div className={commonStyle.footerContainer}>
                        <h3>Загальна сума акту зі знижкою: {formatCurrency(isFinalized ? +actData.amountUAH : (+totaLActSum - +totalDiscount), "UAH")}</h3>
                    </div>
                </>}
            </div>
        </div>}
        {tabShowed === 1 && isFinalized && <ActPayments isMobile={isMobile} payments={actPayments} onUnbindClick={UnbindPayment} />}
        {tabShowed === 2 && <HistoryElement data={actHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
        {tabShowed === 3 && <DocumentArchiveTable documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />}
        <Sidebar visible={visible} position="right" onHide={() => closeSideBarHandler()} className={!isMobile ? commonStyle.sidebar : "w-full"}>
            {(showfields && !isEditField) && <Button label="<<<" type="button" className={commonStyle.blankButton} onClick={() => BackToProductsHandler()} />}
            <form onSubmit={sideBarFormik.handleSubmit}>
                {(!formik.values.division && !isEditField) && <Message className="w-full" text="Виберіть точку продажу для вибору товару" />}
                {(!selectedItem && formik.values.division && !isEditField) && <Message className="w-full" text="Виберіть групу товарів для вибору товару" />}
                <DropdownInput
                    formik={formik}
                    paramName="division"
                    context={ctx.enums.divisions.data}
                    onChange={(val) => setDivision(val)}
                    label="Точка продажу"
                    customStyle="w-full"
                />
                {(formik.values.division && !isEditField) && <div className="p-inputgroup flex-column mt-4">
                    <FloatLabel>
                        <TreeSelect
                            name="set_group"
                            value={selectedItem}
                            onChange={(e) => setGroupValue(e.value)}
                            options={isProducts ? productGroups : serviceGroups}
                            className="w-full" />
                        <label>Назва групи</label>
                    </FloatLabel>
                </div>}
                {(selectedItem && showProductChooseMenu && isProducts) && <DataTable value={products} header={setTableHeader("Товари")} className="mt-4" rows={productLazyState.rows} paginator onPage={onProductsPage} first={productLazyState.first} loading={loading} totalRecords={productsTotalRecords} rowsPerPageOptions={[20, 50]}>
                    <Column field="product_name" header="Назва продукту" />
                    <Column field="total_quantity" header="Кількість" />
                    <Column field="identifier" header="Ідентифікатор" />
                    <Column field="action" body={actionBodyTemplate} />
                </DataTable>}
                {(showProductChooseMenu && !isProducts) && <DataTable value={services} header={setTableHeader("Послуги")} className="mt-4" rows={serviceLazyState.rows} paginator onPage={onServicePage} first={serviceLazyState.first} loading={loading} totalRecords={servicesTotalRecords} rowsPerPageOptions={[20, 50]}>
                    <Column field="name" header="Назва послуги" />
                    <Column field="action" body={actionBodyTemplate} />
                </DataTable>}
                {showfields && (<>
                    <TextInput formik={sideBarFormik} paramName={"product"} label={"Назва товару/послуги"} isDisabled customStyle="w-full" />
                    {sideBarFormik.values.type === "INDIVIDUAL" && (<>
                        <TextInput formik={sideBarFormik} paramName={"identifier"} label={"Ідентифікатор"} isDisabled customStyle="w-full" />
                    </>)}
                    {sideBarFormik.values.type === "PIECE" && (
                        <NumberInput
                            label="Кількість"
                            value={sideBarFormik.values.quantity}
                            onChange={(val) => setQuantity(val)}
                            errors={sideBarFormik.errors.quantity}
                            touched={sideBarFormik.touched.quantity}
                            digits={sideBarFormik.values.measurement_units === "PIECES" ? 0 : 2}
                            customStyle="w-full"
                        />
                    )}
                    <CurrencyAmountInput 
                        amount={sideBarFormik.values.price}
                        currency={sideBarFormik.values.currency}
                        onAmountChange={(val) => setPriceInFields(val)}
                        onCurrencyChange={(val) => sideBarFormik.setFieldValue("currency", val)}
                        errors={sideBarFormik.errors.price}
                        touched={sideBarFormik.touched.price}
                        customStyle="w-full"
                        mandatory
                    />
                    {sideBarFormik.values.type !== "SERVICE" && (<>
                        <CurrencyAmountInput
                            amount={sideBarFormik.values.totalPrice}
                            currency={sideBarFormik.values.currency}
                            onAmountChange={(val) => sideBarFormik.setFieldValue("totalPrice", val)}
                            label="Загальна вартість в валюті розрахунку"
                            errors={sideBarFormik.errors.totalPrice}
                            touched={sideBarFormik.touched.totalPrice}
                            customStyle="w-full"
                            currencyDisabled
                            mandatory
                        />
                        <CurrencyAmountInput
                            amount={sideBarFormik.values.totalPriceUAH}
                            currency="UAH"
                            onAmountChange={(val) => sideBarFormik.setFieldValue("totalPriceUAH", val)}
                            label="Загальна вартість в гривні"
                            errors={sideBarFormik.errors.totalPriceUAH}
                            touched={sideBarFormik.touched.totalPriceUAH}
                            customStyle="w-full"
                            currencyDisabled
                            mandatory
                        />
                    </>)}
                    <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button label={isEditField ? "Редагувати" : "Додати"} severity="success" type="submit" className={`mt-4 ${commonStyle.addButton} w-full`} autoFocus />
                    </div>
                </>)}
            </form>
        </Sidebar>
        <Sidebar visible={productAttachedSidebarVisible} onHide={() => setProductAttachedSidebarVisible(false)} position="right" className={!isMobile ? commonStyle.sidebar : "w-full"} header="Меню додавання прикріплених товарів">
            <DataTable header={"Наявні залишки прикріплених товарів"} emptyMessage="Товари відсутні" value={attachedProducts?.filter(product => product.total_quantity - product.booked > 0)}>
                <Column field="product_name" header="Назва товару" />
                <Column field="total_quantity" header="Кількість" body={rowData => (rowData.total_quantity - rowData.booked)} />
            </DataTable>
            <DataTable header={"Відсутні залишки прикріплених товарів"} emptyMessage="Товари відсутні" value={attachedProducts?.filter(product => product.total_quantity - product.booked <= 0)} className="mt-4">
                <Column field="product_name" header="Назва товару" />
            </DataTable>
            <Button
                label="Додати"
                severity="success"
                type="button"
                onClick={() => AddServiceProductsToTable(attachedProducts?.filter(product => product.total_quantity - product.booked > 0))}
                className={`mt-4 ${commonStyle.addButton} w-full`}
                autoFocus
            />
            <Button
                label="Пропустити"
                severity="info"
                type="button"
                onClick={() => setProductAttachedSidebarVisible(false)}
                className={`mt-4 ${commonStyle.editButton} w-full`}
            />
        </Sidebar>
        <DocumentPrintSidebar sbVisible={printDocuments} onHide={() => setPrintDocuments(false)} actData={actData} toast={toast} />
        <CounterAgentCreationSidebar visible={cagentCreationSidebarVisible} onHide={() => setCagentCreationSidebarVisible(false)}
            toast={toast} ctx={ctx} key={location.pathname} onCreate={(id) => HandleCagentCreation(id)} isClient />
    </form>);
}

export default NewSale;